module.exports = __webpack_public_path__ + "img/9788974649500.3fa32c8a.jpg";